import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';

import {userDatasetEntitlementsStateSelector} from './user-dataset-entitlements-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {EntitlementsFilters, ResourceView} from 'src/modules/entitlements/typedef';

export const userDatasetEntitlementsSlice = getCachedTableDataSlice<
    ResourceView[],
    undefined,
    undefined,
    EntitlementsFilters
>('userDatasetEntitlements');

export const userDatasetEntitlementsActions = userDatasetEntitlementsSlice.actions;
const userDatasetEntitlementsCacheSelector: CachedTableCacheSelector<ResourceView[]>
    = state => state.userPage.tabs.userEntitlements.dataset.entitlements.cache;
export const userDatasetEntitlementsDataSelector: CachedTableDataSelector<ResourceView[]>
    = state => state.userPage.tabs.userEntitlements.dataset.entitlements;
export const userDatasetEntitlementsResultSelector = getCachedTableResultSelector(
    userDatasetEntitlementsCacheSelector,
    userDatasetEntitlementsStateSelector,
);
